import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardState } from './dashboard.state';
import { dashboardFeatureKey } from './dashboard.reducers';

export const selectDashboardState = createFeatureSelector<DashboardState>(dashboardFeatureKey);

export const selectDashboard = createSelector(selectDashboardState, (state: DashboardState) => state);